'use client';

import { usePathname } from 'next/navigation';
import Link from 'next/link';

const categories = [
  { label: 'Latest', slug: 'latest' },
  { label: 'Travel', slug: 'travel' },
  { label: 'Experiences', slug: 'experiences' },
  { label: 'Food', slug: 'food' },
  { label: 'Stories', slug: 'stories' },
];

export function CategoryTabs() {
  const pathname = usePathname();

  // Extract current category from pathname
  const getCurrentCategory = () => {
    if (pathname && pathname.startsWith('/journal/topic/')) {
      const segments = pathname.split('/');
      return segments[3] || 'latest'; // /journal/topic/[category] or /journal/topic/[category]/page/[number]
    }
    // If we're on the main blog page (/journal) or paginated blog (/journal/page/[number]), show latest as active
    if (
      pathname === '/journal' ||
      (pathname && pathname.startsWith('/journal/page/'))
    ) {
      return 'latest';
    }
    return 'latest'; // Default fallback
  };

  const currentCategory = getCurrentCategory();

  return (
    <section className="bg-white">
      <div className="body-container mx-auto py-6">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          {/* Navigation tabs */}
          <nav className="flex space-x-8">
            {categories.map((category) => {
              const isActive = currentCategory === category.slug;
              const href =
                category.slug === 'latest'
                  ? '/journal'
                  : `/journal/topic/${category.slug}`;
              return (
                <Link
                  key={category.slug}
                  href={href}
                  scroll={false}
                  className={`pb-2 text-sm font-medium transition-colors cursor-pointer no-underline ${
                    isActive
                      ? 'text-primary-main border-b-2 border-primary-main'
                      : 'text-gray-600 hover:text-primary-main'
                  }`}
                >
                  {category.label}
                </Link>
              );
            })}
          </nav>
        </div>
      </div>
    </section>
  );
}
